import { BrowserRouter, Routes, Route } from 'react-router-dom';
import StartPage from './StartPage';
import ForkPage from './ForkPage';
import VideoPage from './VideoPage';
import RocketDockPage from './RocketDockPage';
import AcademyPage from './AcademyPage';
import CommPage from './CommPage';
import CargoPage from './CargoPage';
import CorpPage from './CorpPage';
import ConfPage from './ConfPage';
import WalletPage from './WalletPage';


const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<StartPage />} />
      <Route path="/fork" element={<ForkPage />} />
      <Route path="/video" element={<VideoPage />} />
      <Route path="/rocket-dock" element={<RocketDockPage />} />
      <Route path="/academy" element={<AcademyPage />} />
      <Route path="/communication" element={<CommPage />} />
      <Route path="/cargo" element={<CargoPage />} />
      <Route path="/corporation" element={<CorpPage />} />
      <Route path="/hall" element={<ConfPage />} />
      <Route path="/wallet" element={<WalletPage />} />
    </Routes>
  </BrowserRouter>
);

export default App;